// import HeaderHome from "./HeaderHome";

import { ProjectContext } from "@/context/project.context";
import { useChangeRoute } from "@/hooks/useChangeRoute";
import { FILTER_REVIEWS } from "@/modules/Desktop/ProjectDetail/ReviewFilter";
import InputSearchReview from "@/modules/common/ProjectDetail/InputSearchReview";
import { skipNullParams } from "@/utils";
import clsx from "clsx";
import { useRouter } from "next/router";
import { useContext, useState } from "react";

// import Newest from "./Newest";

const ReviewFilter = () => {
  const router = useRouter();

  const handleFilter = (key, value) => {
    router.push({
      query: skipNullParams({
        id: router.query.id,
        [key]: value,
        comment: router.query.comment,
      }),
    });
  };
  const [showFilter, setShowFilter] = useState(false);
  const { numberNewReview } = useContext(ProjectContext);
  const { loading } = useChangeRoute();

  const activeFilter = FILTER_REVIEWS.find(
    (filter) =>
      router.query[filter.key] === filter.value ||
      (!Object.keys(router.query).length && !filter.key && !filter.value)
  );
  return (numberNewReview.totalReview ?? 0) +
    (numberNewReview.totalQuestion ?? 0) >
    0 ? (
    <div className="bg-white p-4 border-b border-b-grey-200">
      <InputSearchReview className="mb-4" />
      {numberNewReview?.today ? (
        <div className="text-grey-600 text-base font-medium mb-2">
          Có {numberNewReview?.today} review mới hôm nay{" "}
          <span className="text-red-600">•</span>
        </div>
      ) : null}
      <div
        className={clsx(
          "text-grey-700 flex gap-1 items-center cursor-pointer duration-300 mt-4",
          showFilter ? "mb-3" : ""
        )}
        onClick={() => setShowFilter(!showFilter)}>
        Lọc:
        <span className="font-semibold flex items-center">
          {" "}
          {activeFilter ? activeFilter?.label : "Tất cả"}{" "}
          <i className="mrv mrv-arrow_drop_down !text-base"></i>
        </span>{" "}
      </div>
      <div
        className={clsx(
          "flex flex-wrap  gap-2 duration-300 overflow-hidden  ",
          showFilter ? " max-h-[240px]" : " max-h-0"
        )}>
        <div
          onClick={() => {
            if (!loading)
              router.push({
                query: skipNullParams({
                  id: router.query.id,
                  comment: router.query.comment,
                }),
              });
          }}
          className={clsx(
            "text-fs-12 text-grey-600 px-3 py-1 rounded-full border border-grey-200  hover:border-blue-400 duration-300",
            Object.keys(router.query).length === 1
              ? "bg-blue-500 border-transparent text-white"
              : "bg-white ",
            loading ? "cursor-not-allowed" : "cursor-pointer"
          )}>
          Tất cả (
          {(numberNewReview.totalReview ?? 0) +
            (numberNewReview.totalQuestion ?? 0)}
          )
        </div>
        {FILTER_REVIEWS.map((filter) => {
          const isActive =
            router.query[filter.key] === filter.value ||
            (!Object.keys(router.query).length && !filter.key && !filter.value);
          return (
            <div
              key={`${filter.key}=${filter.value}`}
              onClick={() => {
                if (!loading) handleFilter(filter.key, filter.value);
              }}
              className={clsx(
                "text-fs-12 text-grey-600 px-3 py-1 rounded-full border border-grey-200  hover:border-blue-400 duration-300",
                isActive
                  ? "bg-blue-500 border-transparent text-white"
                  : "bg-white ",
                loading ? "cursor-not-allowed" : "cursor-pointer"
              )}>
              {filter.label} {`(${numberNewReview[filter.resultKey] ?? 0})`}
            </div>
          );
        })}
      </div>
    </div>
  ) : null;
};

export default ReviewFilter;
